import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { courses, courseCategories } from '../../data/courses';

const CourseCatalog = () => {
  const [filter, setFilter] = useState('All');
  const [search, setSearch] = useState('');

  const filteredCourses = courses.filter(c => {
    const matchesCategory = filter === 'All' || c.category === filter;
    const matchesSearch = c.title.toLowerCase().includes(search.toLowerCase()) || 
                          c.summary.toLowerCase().includes(search.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Course Catalog" 
        description="Comprehensive training programs across safety, emergency response, and leadership disciplines." 
      />
      
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Search & Filters */}
        <div className="mb-12 flex flex-col lg:flex-row gap-6 justify-between items-center bg-white p-4 rounded-2xl shadow-sm border border-slate-200">
          <div className="relative w-full lg:w-96">
            <SafeIcon icon={FiIcons.FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input 
              type="text" 
              placeholder="Search courses..." 
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-brand-navy focus:ring-1 focus:ring-brand-navy text-sm font-medium"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          
          <div className="flex flex-wrap gap-2 justify-center lg:justify-end w-full">
            {courseCategories.map((cat) => (
              <button 
                key={cat} 
                onClick={() => setFilter(cat)}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                  filter === cat 
                    ? 'bg-brand-navy text-white shadow-md' 
                    : 'bg-white text-slate-600 border border-slate-200 hover:border-brand-navy hover:text-brand-navy'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Note */}
        <div className="mb-10 bg-white border-l-4 border-brand-green p-4 rounded-r-lg shadow-sm">
          <p className="text-sm text-brand-navy m-0 font-medium">
            <strong>Important Certification Notice:</strong> Prerequisites, NFPA editions, and certification testing availability must be verified with Boes & Boes prior to registration. Some courses require ProBoard assessment through recognized authorities.
          </p>
        </div>

        {/* Results */}
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
          {filteredCourses.map((course, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl transition-all flex flex-col group p-6">
              <div className="text-xs font-bold text-brand-green uppercase tracking-wider mb-2">{course.category}</div>
              <h3 className="text-xl font-bold text-brand-navy mb-3 line-clamp-2">{course.title}</h3>
              <p className="text-slate-600 text-sm mb-6 flex-grow font-medium leading-relaxed">{course.summary}</p>
              
              <div className="space-y-2 mb-6 text-xs text-slate-500 font-semibold bg-slate-50 p-4 rounded-xl">
                <div className="flex justify-between border-b border-slate-200 pb-2">
                  <span>Duration:</span> <span className="text-brand-navy">{course.duration}</span>
                </div>
                <div className="flex justify-between border-b border-slate-200 py-2">
                  <span>Delivery:</span> <span className="text-brand-navy">{course.delivery}</span>
                </div>
                <div className="flex justify-between pt-2">
                  <span>Standards:</span> <span className="text-brand-navy">{course.standards}</span>
                </div>
              </div>
              
              <Link to="/contact" className="w-full py-3 rounded-xl bg-brand-light border border-slate-200 text-brand-navy font-bold text-sm group-hover:bg-brand-navy group-hover:text-white transition-colors text-center">
                Request This Course
              </Link>
            </div>
          ))}
          {filteredCourses.length === 0 && (
            <div className="col-span-full text-center py-12 text-slate-500">
              No courses found matching your criteria.
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default CourseCatalog;